import React, { ChangeEvent, useMemo } from 'react';
// Store
import { useDispatch, useSelector } from 'react-redux';
// Models
import IOption from 'app/models/Option';
// Actions
import { CasesActions } from 'app/store/Cases/Cases.slice';
// Selector
import { selectDuplicatesFilter, selectDuplicateDocumentAsOptions } from 'app/store/Cases/Cases.selectors';
// Mui
import { Autocomplete, Container, TextField } from '@mui/material';
// Components
import ColumnSwitcher from 'app/components/ColumnSwitcher';
import { Select } from 'app/components/Mui';
// i18next
import { useTranslation } from 'react-i18next';

const DuplicatesFilter:React.FC = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useDispatch();
  // State
  const filter = useSelector(selectDuplicatesFilter);
  const documentsOptions = useSelector(selectDuplicateDocumentAsOptions) || [];

  const handleChange = (event:ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    dispatch(CasesActions.setDuplicatesFilter({
      field: name || '',
      value: value
    }));
  }

  const handleSelectDocument = (_:any, value:IOption | null) => {
    dispatch(CasesActions.setDuplicatesFilter({
      field: 'documentBy',
      value: value
    }));
  }

  const pagesOptions = useMemo(() => [
    { id: 'all', name: t('pages.duplicates.allLabel') },
    { id: 'hasWorkspacePages', name: t('pages.duplicates.hasWorkspacePages') },
    { id: 'hasWorkspaceDuplicates', name: t('pages.duplicates.hasWorkspaceDuplicates') }
    // eslint-disable-next-line
  ], [])

  return (
    <Container maxWidth={false} sx={{ display: 'flex', alignItems: 'center', gap: 4, py: 4 }}>
      <ColumnSwitcher />
      <Autocomplete
        sx={{ minWidth: 280, maxWidth: 320 }}
        options={documentsOptions}
        onChange={handleSelectDocument}
        value={filter.documentBy}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t('labels.byDocument')}
            size="small"
            margin="none"
          />
        )}
      />
      <Select
        sx={{ minWidth: 280, maxWidth: 320 }}
        label={t('labels.pagesFilter')}
        value={filter.pages} name="pages"
        onChange={handleChange}
        options={pagesOptions}
        size="small"
        margin="none"
      />
    </Container>
  )
}

export default DuplicatesFilter;